import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
// Constants - Functions
import { WEB_SERVICE_MIMS } from "../../../../config/constants";
import { isClinicOrHome } from "../../../../config/validateApplication";
import Axios from "../../../../config/axios";
// Components
import { ActionsContainer, ManagementDiv, SaveAndCancelDiv, SaveButton, CancelButton, ColorToggleDiv, ColorToggleText } from "./styles";
import ButtonWithIcon from "../../../buttonWithIcon";
import ToggleSwitch from "../../../toggleSwitch";
// Assets
import EditUserImg from "../../../../assets/icons/btn_edit_user.svg";

const ActionsManagement = ({
  handleSubmit,
  isDisabledInputs,
  setIsDisabledInputs,
  software,
  patientId,
  isColorToggleActive,
  setIsColorToggleActive,
}) => {
  const [isThePatientSoftwareActive, setIsThePatientSoftwareActive] = useState(true);
  const [t] = useTranslation("global");

  // Fetching patient inactivity
  useEffect(() => {
    Axios("get", `${WEB_SERVICE_MIMS}/patient-inactivity/get/${patientId}/${software}`)
      .then(({ data }) => {
        setIsThePatientSoftwareActive(data.isThePatientSoftwareActive);
      })
      .catch((error) => {
        console.log("Get patient inactivity by software: ", error);
      });

    return () => {
      setIsThePatientSoftwareActive(true);
    };
  }, [patientId, software]);

  const enableData = (e) => {
    e.preventDefault();
    setIsDisabledInputs(false);
  };

  const disableData = (e) => {
    e.preventDefault();
    setIsDisabledInputs(true);
    window.location.reload();
  };

  return (
    <ActionsContainer>
      <ManagementDiv>
        {isDisabledInputs ? (
          <ButtonWithIcon
            icon={EditUserImg}
            name={t("prescriptions_editPrescriptionsButton")}
            onClick={enableData}
            active={isThePatientSoftwareActive}
            background="#999"
          />
        ) : (
          <>
            <SaveAndCancelDiv>
              <SaveButton onClick={handleSubmit}>{t("save")}</SaveButton>
              <CancelButton onClick={disableData}>{t("discard_changes")}</CancelButton>
            </SaveAndCancelDiv>
            {isClinicOrHome(software) && (
              <ColorToggleDiv>
                <ColorToggleText>{t("colorblindMode")}</ColorToggleText>
                <ToggleSwitch
                  isActive={isColorToggleActive}
                  setIsActive={() => setIsColorToggleActive(!isColorToggleActive)}
                  inactiveColor="#ccc"
                  activeColor="#39b54a"
                />
              </ColorToggleDiv>
            )}
          </>
        )}
      </ManagementDiv>
    </ActionsContainer>
  );
};

export default ActionsManagement;
